import { render } from "./WeighingSystem.vue?vue&type=template&id=651b11e6&scoped=true"
import script from "./WeighingSystem.vue?vue&type=script&lang=js"
export * from "./WeighingSystem.vue?vue&type=script&lang=js"

import "./WeighingSystem.vue?vue&type=style&index=0&id=651b11e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651b11e6"]])

export default __exports__